<script setup lang="ts">
import { Vue3Snackbar } from 'vue3-snackbar';
</script>

<template>
  <Header />

  <main class="min-h-dvh lg:pt-navbar">
    <Vue3Snackbar top :duration="4000" error="#b13a3a" />
    <RouterView />
  </main>

  <Footer />
</template>
